const de = {
  nav: {
    product: "Produkt",
    howItWorks: "So funktioniert's",
    integrations: "Integrationen",
    pricing: "Preise",
    enterprise: "Enterprise",
    faq: "FAQ",
    signIn: "Anmelden",
    getStarted: "Kostenlos starten — 49 $ Credits",
  },
  hero: {
    badge: "Salesforce-nativ · Entwickelt von DulipTech",
    line1: "KI-Agenten liefern —",
    line2: "direkt in Salesforce.",
    line3: "Immer einen Schritt voraus.",
    sub: "Gyeno ist die Salesforce-native Plattform, um KI-Agenten direkt in der Org zu bauen, zu testen und zu deployen, die Ihr Team bereits nutzt. Kein neuer Stack. Kein Abo.",
    ctaPrimary: "Kostenlos starten — nur 49 $ Credits",
    ctaSecondary: "Mit Vertrieb sprechen",
    thinking: "Agent denkt nach…",
    caption: "Gyeno Studio — KI-Agenten auf Salesforce entwerfen, testen und ausliefern.",
  },
  trust: {
    builtFor: "Für Salesforce gebaut",
    native: "Nativ in Ihrer Org",
    byDulip: "Entwickelt von DulipTech — Salesforce-Beratung & KI-Produkte",
    regions: "Verfügbar in US · UK · Nahost · APAC",
  },
  manifesto: {
    kicker: "Das Gyeno-Prinzip",
    ch1t: "Ihre Salesforce ist die Plattform.",
    ch1b: "Agenten sollten nicht in einer separaten App leben, die Sie erst verkabeln müssen. Gyeno bindet sich direkt an die Apex- und Flow-Logik Ihrer Org und läuft innerhalb von Salesforce — dort, wo Ihre Daten und Ihr Team bereits sind.",
    ch2t: "Kostenlos bauen. Nur Nutzung zahlen.",
    ch2b: "Agenten bauen ist unbegrenzt und für immer kostenlos. Es gibt kein Abo. Sie kaufen AI Credits ab 49 $ und verbrauchen sie nur, wenn Ihre Agenten tatsächlich laufen.",
    ch3t: "Vertrauen ist ein Feature.",
    ch3b: "Action Runs, Policy Violations, Error Logs, Health — jede Agenten-Entscheidung ist beobachtbar und wird im Berechtigungsmodell Ihrer Org gesteuert. Enterprise-Kontrolle ist kein Add-on.",
  },
  how: {
    kicker: "So funktioniert's",
    title: "Von der leeren Leinwand zum Live-Agenten in drei Zügen.",
    s1t: "Im Studio starten",
    s1b: "Registrieren und ab Tag eins vordefinierte Agenten nutzen — oder einen neuen Agenten auf leerer Leinwand im Gyeno Studio starten, direkt in Salesforce.",
    s2t: "Echte Actions kombinieren, LLM wählen",
    s2b: "Gestufte Workflows aus den Apex- und Flow-Actions Ihrer Org zusammenstellen — GetPipeline, FindStalledDeals, LogTask — ohne Code. Claude, GPT oder Gemini pro Agent wählen.",
    s3t: "Live testen, dann veröffentlichen",
    s3b: "Chatten Sie mit Ihrem Agenten in der Live Test Console, bevor es jemand anderes tut. Versionierte Releases mit Notizen veröffentlichen — sicher iterieren, einfach zurückrollen.",
    cta: "Kompletten Ablauf ansehen",
  },
  features: {
    kicker: "Warum Teams Gyeno wählen",
    title: "Alles, was Sie brauchen. Nichts, das Sie betreuen müssen.",
    f1t: "Unbegrenzter kostenloser Agent Builder",
    f1b: "Bauen Sie so viele KI-Agenten wie nötig — das Erstellen ist immer kostenlos.",
    f2t: "14 Tage Premium-Support",
    f2b: "Jedes neue Konto erhält zwei Wochen praktische Implementierungshilfe für Ihren konkreten Use Case. Echte Engineers, keine generischen Docs.",
    f3t: "Freie Wahl führender LLMs",
    f3b: "Bringen Sie das Modell mit, dem Sie vertrauen: Claude, OpenAI GPT und Google Gemini — pro Agent wechselbar, kein Lock-in.",
    f4t: "Einfacher, günstiger Einstieg",
    f4b: "Kein Abo. Einmaliger Mindestkauf von 49 $ AI Credits — zahlen Sie nur, was Ihre Agenten tatsächlich verbrauchen.",
    f5t: "Vordefinierte, sofort nutzbare Agenten",
    f5b: "Starten Sie ab Tag eins mit vorgebauten Agenten — Plug-and-play, kein Kaltstart.",
    f6t: "Bring-Your-Own-Key (Enterprise)",
    f6b: "Eigene Enterprise-LLM-Keys und -Verträge anbinden — volle Kosten- und Datenkontrolle.",
  },
  channels: {
    kicker: "Überall deployen",
    title: "Ein Agent. Jeder Kanal, den Ihre Kunden nutzen.",
    whatsapp: "Meta Cloud API, direkt — auf WhatsApp empfangen und antworten.",
    instagram: "Kunden in Instagram-DMs erreichen.",
    teams: "Agenten in Microsoft Teams bringen.",
    slack: "Antworten, wo Ihr Team arbeitet — Slack.",
    web: "Einbettbares Widget für jede Web-App.",
  },
  pricingTeaser: {
    title: "Kein Abo. Zahlen Sie nur, was Sie nutzen.",
    sub: "Agenten bauen ist kostenlos und unbegrenzt. Aktivierung mit einmaligem Mindestkauf von 49 $ — Credits werden nur verbraucht, wenn Agenten laufen.",
    cta: "Preise ansehen",
  },
  proof: {
    kicker: "Von Salesforce-Teams genutzt",
    placeholder: "Kundenlogo",
  },
  entCallout: {
    title: "Enterprise-Größe? Bringen Sie Ihren eigenen LLM-Key mit.",
    sub: "Binden Sie die Claude-, OpenAI- oder Gemini-Verträge Ihrer Organisation an — volle Kosten- und Datenkontrolle, mit Implementierung durch das DulipTech-Team.",
    cta: "Kontakt aufnehmen",
  },
  footer: {
    tagline: "Just One Step Ahead.",
    product: "Produkt",
    company: "Unternehmen",
    legal: "Rechtliches",
    privacy: "Datenschutz",
    terms: "AGB",
    contact: "Kontakt",
    signup: "Registrieren",
    regions: "Verfügbar in den USA, UK, Nahost und APAC.",
    rights: "© 2026 DulipTech. Alle Rechte vorbehalten.",
    builtBy: "Gyeno wird von DulipTech entwickelt.",
  },
  cookie: {
    text: "Wir verwenden Cookies für den Betrieb dieser Website und, mit Ihrer Einwilligung, zur Nutzungsmessung. Siehe unsere",
    accept: "Alle akzeptieren",
    reject: "Nur Notwendige",
  },
  auth: {
    signupTitle: "Business-Konto erstellen",
    signupSub: "Kostenlose vordefinierte Agenten warten. Aktivieren Sie mit 49 $ Credits, wann immer Sie bereit sind.",
    fullName: "Vollständiger Name",
    email: "Geschäftliche E-Mail",
    password: "Passwort",
    company: "Firmenname",
    country: "Land / Region",
    sfOrg: "Salesforce-Org-Typ (optional)",
    createAccount: "Konto erstellen",
    haveAccount: "Bereits ein Konto?",
    signIn: "Anmelden",
    loginTitle: "Willkommen zurück",
    loginSub: "Melden Sie sich bei Ihrem Gyeno-Konto an.",
    noAccount: "Neu bei Gyeno?",
    signUp: "Registrieren",
  },
  pricingPage: {
    kicker: "Preise",
    title: "Keine Abos. Nur AI Credits.",
    sub: "Alles rund ums Bauen ist kostenlos. Sie zahlen nur, was Ihre Agenten verbrauchen — ab einem einmaligen Mindestkauf von 49 $.",
    freeTitle: "Agenten bauen",
    freeDesc: "Unbegrenzte Agenten, unbegrenzte Änderungen, das volle Studio — für immer kostenlos.",
    freeTag: "Kostenlos",
    predefTitle: "Vordefinierte Agenten",
    predefDesc: "Vorgebaute Agenten, ab Tag eins nutzbar. Kein Kaltstart.",
    predefTag: "Kostenlos",
    creditsTitle: "AI Credits",
    creditsDesc: "Einmaliger Mindestkauf von 49 $ aktiviert Ihr Konto. Credits werden durch tatsächliche Nutzung verbraucht — LLM-Aufrufe und Actions.",
    creditsTag: "Ab 49 $",
    supportNote: "Jedes neue Konto enthält 14 Tage Premium-Implementierungssupport.",
    tableTitle: "Credit-Verbrauchsraten",
    tableNote: "Die finalen Raten werden derzeit festgelegt und hier veröffentlicht.",
    tableCol1: "Vorgang",
    tableCol2: "Credits",
    row1: "LLM-Aufruf (Standardmodell)",
    row2: "LLM-Aufruf (Premiummodell)",
    row3: "Salesforce-Action-Ausführung",
    row4: "Kanalnachricht (WhatsApp / Teams / Slack)",
    tbd: "Folgt",
    calcTitle: "Wählen Sie Ihre Start-Credits",
    calcSub: "Mindestens 49 $ — jederzeit aufladbar.",
    calcCredits: "Credits",
    cta: "Registrieren & Credits kaufen",
    entTitle: "Eigene LLM-Keys oder ein individueller Vertrag?",
    entSub: "Enterprise-BYOK, Volumenpreise und individuelle Implementierung übernimmt unser Team direkt.",
    entCta: "Kontakt aufnehmen",
    faqTitle: "Fragen zur Abrechnung",
    bq1: "Verfallen Credits?",
    ba1: "Die Verfallsrichtlinie wird derzeit finalisiert. Fragen Sie uns über das Kontaktformular — wir bestätigen die Regelung für Ihre Region vor dem Kauf.",
    bq2: "Gibt es Rückerstattungen für ungenutzte Credits?",
    ba2: "Die Erstattungsrichtlinie wird derzeit finalisiert. Kontaktieren Sie uns vor dem Kauf für die aktuellen Bedingungen.",
    bq3: "Wie lade ich auf?",
    ba3: "Kaufen Sie jederzeit zusätzliche Credits über Ihr Konto — nach der ersten 49-$-Aktivierung ohne Mindestbetrag.",
    needsInput: "Richtlinie in Abstimmung",
  },
  contactPage: {
    kicker: "Enterprise",
    title: "Lassen Sie uns Ihren Salesforce-KI-Rollout planen.",
    sub: "Für große Orgs, die Bring-Your-Own-Key, individuelle Verträge oder Implementierung durch das DulipTech-Team wollen.",
    responseTime: "Unser Team antwortet innerhalb von 1 Werktag.",
    fullName: "Vollständiger Name",
    email: "Geschäftliche E-Mail",
    company: "Unternehmen",
    jobTitle: "Position",
    country: "Land / Region",
    companySize: "Unternehmensgröße",
    sfEdition: "Salesforce Edition (optional)",
    useCase: "Beschreiben Sie Ihren Use Case",
    contactMethod: "Bevorzugter Kontaktweg",
    send: "Anfrage senden",
    success: "Ihre E-Mail ist bereit zum Senden — wir antworten innerhalb von 1 Werktag.",
    demoTitle: "Lieber eine Live-Demo?",
    demoSub: "Unser Kalender wird gerade eingerichtet — nutzen Sie in der Zwischenzeit das Kontaktformular oben.",
    demoKicker: "Demo buchen",
    demoLead: "Wählen Sie einen passenden Termin — ein DulipTech-Engineer führt Sie live durch Gyeno Studio, in Ihrem Kontext.",
    demoScroll: "30-minütige Live-Tour mit einem DulipTech-Engineer vereinbaren.",
    demoCta: "Demo buchen",
    byokTitle: "Bring-Your-Own-Key",
    byokDesc: "Binden Sie Ihre Enterprise-Verträge für Claude, OpenAI oder Gemini an. Ihre Keys, Ihre Datenvereinbarungen, Ihre Kostenkontrolle.",
    implTitle: "Individuelle Implementierung",
    implDesc: "DulipTech-Engineers entwerfen, bauen und steuern Ihre Agentenflotte mit Ihnen — vom ersten Use Case bis zum Org-weiten Rollout.",
    secTitle: "Sicherheit & Governance",
    secDesc: "Agenten laufen im Berechtigungsmodell Ihrer Org — mit voller Sicht auf Action Runs, Policy Violations und Error Logs.",
  },
  faqPage: {
    kicker: "FAQ",
    title: "Antworten, direkt.",
    sub: "Alles, was Salesforce-Teams vor dem Start fragen.",
    stillQ: "Noch eine Frage?",
    stillCta: "Kontakt aufnehmen",
  },
  legal: {
    reviewFlag: "Entwurf zur Prüfung — Rechtsberatung sollte diesen Text vor dem öffentlichen Launch prüfen.",
    inputFlag: "Mit [NEEDS BUSINESS INPUT] markierte Abschnitte benötigen finale Richtlinienentscheidungen vor dem Launch.",
  },
  common: {
    selectPlaceholder: "Auswählen…",
  },
};

export default de;
